import type { GetGoodsListCondition, GoodsItem } from '../types';

export default class Handler {
  condition: GetGoodsListCondition;

  constructor(condition: GetGoodsListCondition) {
    this.condition = condition;
  }

  handle(goodsList: GoodsItem[]): GoodsItem[] {
    return goodsList;
  }
}
